export const isNew = function (startDtm) {
  var sdtm = new Date(startDtm)
  var nowdtm = new Date()

  if (sdtm.getTime() > nowdtm.getTime() - 1000 * 60 * 60 * 24 * 1) {
    return true
  } else {
    return false
  }
}
